import React from 'react';
import { DateTime } from 'luxon';
import IrGraph from '../../../ir-graph';
import { TestGraphParseData } from '../../../../types';

const TestReportGraph: React.FC<{
  filters: any;
  graphData: TestGraphParseData;
  isLoading?: boolean;
  onDateTimeSelectionChange: (
    label: string,
    startDate: DateTime,
    endDate: DateTime,
    displayText: string,
  ) => void;
}> = ({ filters, graphData, isLoading = false, onDateTimeSelectionChange }) => (
  <div className="test-report-graph-container">
    {/* <div className="test-report-graph-header"> */}
    {/* <span>All Test Report Data</span> */}
    {/* </div> */}
    <div className="test-report-graph">
      <IrGraph
        testGraphData={graphData}
        filters={filters}
        isLoading={isLoading}
        showError={false}
        showDateFilter={true}
        onDateTimeSelectionChange={onDateTimeSelectionChange}
      />
    </div>
  </div>
);

export default TestReportGraph;
